import INVENTORY_API_BASE_URL from "../../config/api";
import { useState, useEffect } from "react";
import "./manageprint.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";

function Manageprint() {
  const [data, setData] = useState([]);

  const getStatusColor = (status) => {
    switch (status) {
      case "Work Not Start Yet":
        return "red";
      case "Work in Progress":
        return "blue";
      case "Work completed":
        return "green";
      default:
        return "black";
    }
  };

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getOrder`).then((response) => {
      setData(response.data);
    });
  }, []);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  return (
    <div>
      <h6 className="manageprint">
        <h5>Manage Printing Status</h5>
      </h6>
      <br />

      <div className="manageprintcontainer">
        <div className="manageprintcontent">

      <Table responsive className="printtab">
        <thead>
          <tr>
            <th>Order No</th>
            <th>Vehicle Detail</th>
            <th>PO Date</th>
            <th>Title</th>
            <th>Medium</th>
            <th>SKU</th>
            <th>Order Quantity</th>
            <th>Dispatched Quantity</th>
            <th>Balance</th>
            <th>Order Status</th>
          </tr>
        </thead>
        <br />
        <tbody>
          {data.map((order) =>
            order.updatedQuantity.map((item, itemIndex) => (
              <tr key={`${order.orderid}-${itemIndex}`}>
                {itemIndex === 0 && (
                  <>
                    <td rowSpan={order.updatedQuantity.length}>
                      {order.orderid}
                    </td>

                    <td rowSpan={order.updatedQuantity.length}>
                      {order.vehicle}
                    </td>
                    <td rowSpan={order.updatedQuantity.length}>
                      {formatDate(order.ApprovalDate)}
                    </td>
                  </>
                )}
                <td>{item.title}</td>
                <td>{item.Medium}</td>
                <td>{item.sku}</td>
                <td>{item.approvedquantity}</td>
                <td>{item.DispatchQuantity}</td>
                <td>{item.Balance}</td>
                <td
                  style={{
                    color: getStatusColor(item.Currentstatus),
                    fontWeight: "bold",
                  }}
                >
                  {item.Currentstatus}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </Table>
      </div>
      </div>
    </div>
  );
}

export default Manageprint;
